import {
  FETCH_WORKSPACES_REQUEST, FETCING_WORKSPACES_SUCCEEDED, FETCING_WORKSPACES_FAILED,
  FETCH_WORKSPACE_REQUEST, FETCHING_WORKSPACE_SUCCEEDED, FETCHING_WORKSPACE_FAILED,
  SWITCH_WORKSPACE_REQUEST, SWITCH_WORKSPACE, UPDATE_WORKSPACE_REQUEST, UPDATE_WORKSPACE_SUCCEEDED, UPDATE_WORKSPACE_FAILED,
  NUDGE_TRIGGERED_REQUEST, NUDGE_TRIGGERED_SUCCEEDED, NUDGE_TRIGGERED_FAILED, TRIGGER_NUDGE
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';

import AsyncLocalStorageService from '../services/localstorage.async.service';
import AuthInterceptor from "services/auth.interceptor";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const WORKSPACE_URL = `${apiUrl}/api/2.0/workspaces`;

/**
 * Fetch worspaces for user
*/
export const fetchWorkspaces = createAction(FETCH_WORKSPACES_REQUEST);

const fetchWorkspacesSucceeded = createAction(FETCING_WORKSPACES_SUCCEEDED, (response) => {
  return response;
})

const fetchWorkspacesFailed = createAction(FETCING_WORKSPACES_FAILED, (error) => {
  return error;
})

function* fetchWorkspacesSaga(action) {

  const fetchWorkspacesAPI = () => {
    return axios.get(WORKSPACE_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchWorkspacesAPI);
    yield put(fetchWorkspacesSucceeded(response));
  } catch (error) {
    yield put(fetchWorkspacesFailed(error));
  }
}

/**
 * Fetch worspace for user
*/
export const fetchWorkspace = createAction(FETCH_WORKSPACE_REQUEST, (id) => {
  return id;
})

const fetchWorkspaceSucceeded = createAction(FETCHING_WORKSPACE_SUCCEEDED, (response) => {
  return response;
})

const fetchWorkspaceFailed = createAction(FETCHING_WORKSPACE_FAILED, (error) => {
  return error;
})

function* fetchWorkspaceSaga(action) {
  const id = action.payload;

  const fetchWorkspaceAPI = () => {
    return axios.get(`${WORKSPACE_URL}/${id}`).then(response => response.data);
  }

  try {
    const response = yield call(fetchWorkspaceAPI);
    yield put(fetchWorkspaceSucceeded(response));
  } catch (error) {
    yield put(fetchWorkspaceFailed(error));
  }
}

/**
 * Update workspace for user
*/

export const updateWorkspace = createAction(UPDATE_WORKSPACE_REQUEST, (id, request) => {
  return {
    id: id,
    request: request,
  }
})

const updateWorkspaceSucceeded = createAction(UPDATE_WORKSPACE_SUCCEEDED, (response) => {
  return response;
})

const updateWorkspaceFailed = createAction(UPDATE_WORKSPACE_FAILED, (error) => {
  return error;
})

function* updateWorkspaceSaga(action) {
  const {id, request} = action.payload;

  const updateWorkspaceAPI = () => {
    return axios.put(`${WORKSPACE_URL}/${id}`, request).then(response => response.data);
  }

  try {
    const response = yield call(updateWorkspaceAPI);
    yield put(updateWorkspaceSucceeded(response));
  } catch (error) {
    yield put(updateWorkspaceFailed(error));
  }
}

// Nudge

export const nudgeTriggered = createAction(NUDGE_TRIGGERED_REQUEST, (id, request) => {
  return {
    id: id,
    request: request,
  };
})

export const nudgeTriggeredSucceded = createAction(NUDGE_TRIGGERED_SUCCEEDED, (id, response)=> {
  return {
    id: id,
    response: response
  };
})

export const nudgeTriggeredFailed = createAction(NUDGE_TRIGGERED_FAILED, (error)=> {
  return {
    error: error
  };
})

function* nudgeTriggeredSaga(action) {
  const {id, request} = action.payload;

  const nudgeTriggerAPI = () => {
    return axios.put(`${WORKSPACE_URL}/update-nudge`, request).then(response => response.data);
  }

  try {
    const response = yield call(nudgeTriggerAPI);
    yield put(nudgeTriggeredSucceded(id, response));
  } catch (error) {
    yield put(nudgeTriggeredFailed(error));
  }
}

export const triggerNudge = createAction(TRIGGER_NUDGE)

/**
 * Switch storyboard
*/
export const switchWorkspace = createAction(SWITCH_WORKSPACE_REQUEST);
export const switchWorkspaceSucceeded = createAction(SWITCH_WORKSPACE);

function* switchWorkspaceSaga(action) {
  const workspace = action.payload;
  AsyncLocalStorageService.setItem('appId', workspace.id);
  AuthInterceptor.updateAppId();
  yield put(switchWorkspaceSucceeded(workspace));
}

export default function* workspaceSaga() {
  yield takeEvery(FETCH_WORKSPACES_REQUEST, fetchWorkspacesSaga);
  yield takeEvery(FETCH_WORKSPACE_REQUEST, fetchWorkspaceSaga);
  yield takeEvery(UPDATE_WORKSPACE_REQUEST, updateWorkspaceSaga);
  yield takeEvery(NUDGE_TRIGGERED_REQUEST, nudgeTriggeredSaga);
  yield takeEvery(SWITCH_WORKSPACE_REQUEST, switchWorkspaceSaga);
};